import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesSharing } from "../../constants";

export const requestDeleteSharingSchedule = async (
  sharingScheduleId: string
): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesSharing.SharingSchedules, sharingScheduleId)
  );
};
